<template>
	<a href="#" class="skipcontent" role="button" tabindex="0" @keyup.enter.prevent="scrollToContent" :title="$t('skipcontent')" v-text="$t('skipcontent')"></a>
</template>

<script>
export default {
	methods: {
		scrollToContent() {
			var firstArticleMenuLink = document.querySelector('.content-wrapper a:not(.header-link)');
			if (typeof firstArticleMenuLink !== 'undefined') {
				firstArticleMenuLink.focus();
			}
			return false;
		},
	}
}
</script>